import { Splide, SplideSlide } from '@splidejs/react-splide';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useRef } from 'react';
import { isEmpty } from 'validate.js';

import Badge from 'dpl/common/design_system/Badge';

export default function BreedAvailability({
  className,
  availablePuppyCount,
  availableAdultDogsCount,
  formattedUpcomingLittersDueDates,
  splideOptions
}) {
  const splideRef = useRef();

  const details = useMemo(() => {
    return [
      availablePuppyCount > 0 && {
        color: 'teal',
        description: `${availablePuppyCount} ${availablePuppyCount === 1 ? 'puppy' : 'puppies'} available`
      },
      ...formattedUpcomingLittersDueDates.map(formattedDueDate => ({
        color: 'blue',
        description: `Litter due ${formattedDueDate}`
      })),
      availableAdultDogsCount > 0 && {
        color: 'gray',
        description: `${availableAdultDogsCount} adult ${availableAdultDogsCount === 1 ? 'dog' : 'dogs'} available`
      }
    ].filter(Boolean);
  }, []);

  if (isEmpty(details)) return null;

  return (
    <Splide
      ref={splideRef}
      options={{
        arrows: false,
        pagination: false,
        autoWidth: true,
        snap: true,
        wheel: true,
        gap: 8,
        drag: true,
        keyboard: true,
        releaseWheel: true,
        ...splideOptions
      }}
      className={classnames('BreedAvailability', className)}
    >
      {details.map(({ color, description }, index) => (
        <SplideSlide key={index}>
          <Badge color={color} className="nowrap">
            {description}
          </Badge>
        </SplideSlide>
      ))}
    </Splide>
  );
}

BreedAvailability.propTypes = {
  className: PropTypes.string,
  availablePuppyCount: PropTypes.number.isRequired,
  availableAdultDogsCount: PropTypes.number.isRequired,
  formattedUpcomingLittersDueDates: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  splideOptions: PropTypes.object
};

BreedAvailability.defaultProps = {
  className: null,
  splideOptions: null,
  formattedUpcomingLittersDueDates: []
};
